import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { publicInstance } from 'lib/axiosConfig';

interface FeatureNotification {
  id: number;
  email: string;
  feature: string;
  created_at: string;
}

interface FeatureNotificationState {
  notifications: FeatureNotification[];
  isLoading: boolean;
  error: string | null;
}

const initialState: FeatureNotificationState = {
  notifications: [],
  isLoading: false,
  error: null,
};

export const saveFeatureNotification = createAsyncThunk(
  'featureNotifications/save',
  async (
    { email, feature_name }: { email: string; feature_name: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await publicInstance.post(
        '/feature-notifications/create',
        {
          email,
          feature_name,
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

export const fetchFeatureNotifications = createAsyncThunk(
  'featureNotifications/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await publicInstance.get(
        '/feature-notifications/get'
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

const featureNotificationSlice = createSlice({
  name: 'featureNotifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveFeatureNotification.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(saveFeatureNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications.push(action.payload);
      })
      .addCase(saveFeatureNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchFeatureNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFeatureNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload;
      })
      .addCase(fetchFeatureNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default featureNotificationSlice.reducer;
